<template>
  <div class="card-body">
    <ValidationObserver ref="form">
      <!-- <form @submit.prevent="submitData(invalid)"> -->
      <!-- <div class="form-group feedback-input">
          <h4>{{ $t("Please_Enter_Room_Information") }}</h4>
        </div> -->
      <validation-provider
        v-slot="{ errors }"
        rules="required"
        name="HotelName"
      >
        <div class="form-group">
          <label>{{ $t("Hotel") }}/{{ $t("Restaurant") }}</label>
          <input
            v-model="model.location"
            type="text"
            class="form-control"
            :disabled="true"
            :placeholder="$t('Enter_hotel_name')"
          />
          <span class="error">{{ errors[0] }}</span>
        </div>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        rules="required"
        name="RoomNumber"
      >
        <div class="form-group">
          <label>{{ $t("Room_Number") }}</label>
          <base-select
            :options="rooms"
            v-model="model.room_number"
            option-label="name"
            :placeholder="$t('Enter_room_number')"
            :required="true"
            autofocus
          ></base-select>
          <span class="error">{{ errors[0] }}</span>
        </div>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        rules="required"
        name="FirstName"
      >
        <div class="form-group">
          <label>{{ $t(`BookerName`) }}</label>
          <input
            v-model="model.customer_first_name"
            type="text"
            class="form-control"
            :placeholder="$t(`Enter`) + ' ' + $t(`BookerName`)"
          />
          <span class="error">{{ errors[0] }}</span>
        </div>
      </validation-provider>

      <validation-provider
        v-slot="{ errors }"
        rules="required|numeric"
        name="phoneNumber"
      >
        <div class="form-group">
          <label>{{ $t("Phone Number") }}</label>
          <input
            v-model="model.customer_phone_number"
            type="text"
            class="form-control"
            :placeholder="$t('enter_phone_number')"
          />
          <span class="error">{{ errors[0] }}</span>
        </div>
      </validation-provider>
      <!-- </form> -->
    </ValidationObserver>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "BaseRoomService",
  data() {
    return {
      model: {
        room_number: null,
        customer_first_name: null,
        location: null,
        customer_phone_number: null,
      },
    };
  },

  computed: {
    loading() {
      return store.getters["order/loading"];
    },
    order_info() {
      return store.getters["order/order_info"];
    },
    state_order() {
      return store.getters["order/state_order"];
    },
    btn_state() {
      return store.getters["location_selected/btnState"];
    },
    placeSelected() {
      return store.getters["location_selected/placeSelected"];
    },
    hotel() {
      return store.getters["location_selected/placeSelected"] || {};
    },
    hotelType() {
      return store.getters["location_selected/placeType"];
    },
    rooms() {
      return store.getters["location/locations"] || [];
    },
  },
  watch: {
    model: {
      handler(value) {
        this.submitData();
      },
      deep: true,
    },
  },
  mounted() {
    this.getData();
    this.setData();
  },
  methods: {
    async setData() {
      // this.model.customer_first_name = this.order_info.customer_first_name;
    },
    async getData() {
      let data = {
        type_id: this.hotel.id,
        type: "ROOM",
      };
      await store.dispatch("location/getLocations", data);
      this.model = this.order_info;
      this.model.location = this.placeSelected.title;
    },

    async submitData() {
      // console.log(this.model);
      await this.$store.dispatch("order/setOrderInfo", this.model);
      const isValid = await this.$refs.form.validate();
      this.$emit("valid", isValid);
      // await store.dispatch("order/submitPendingOrder", { id: 0 });
      // if (this.state_order) {
      //   await this.$store.dispatch("order/clearOrder");
      //   await this.$router.push({ name: "ordercompleted" });
      // }
    },
  },
};
</script>